var map = {
  "./ht.eager.json": [
    "837245",
    [
      2778
    ]
  ],
  "./ko.eager.json": [
    "802371",
    [
      66524
    ]
  ],
  "./hy.eager.json": [
    "709186",
    [
      87059
    ]
  ],
  "./mi.eager.json": [
    "18031",
    [
      61152
    ]
  ],
  "./ca.eager.json": [
    "787513",
    [
      95558
    ]
  ],
  "./th.eager.json": [
    "810325",
    [
      13538
    ]
  ],
  "./vi.eager.json": [
    "131284",
    [
      49649
    ]
  ],
  "./pt.eager.json": [
    "524613",
    [
      90661
    ]
  ],
  "./es-ES.eager.json": [
    "235004",
    [
      12257
    ]
  ],
  "./de.eager.json": [
    "849466",
    [
      28859
    ]
  ],
  "./fa.eager.json": [
    "446204",
    [
      5721
    ]
  ],
  "./pt-BR.eager.json": [
    "193700",
    [
      7806
    ]
  ],
  "./id.eager.json": [
    "24696",
    [
      91469
    ]
  ],
  "./es.eager.json": [
    "948313",
    [
      3998
    ]
  ],
  "./en-GB.eager.json": [
    "132228",
    [
      10017
    ]
  ],
  "./en-AU-x-unimelb.eager.json": [
    "368677",
    [
      5354
    ]
  ],
  "./ms.eager.json": [
    "799105",
    [
      17494
    ]
  ],
  "./nb.eager.json": [
    "278029",
    [
      80282
    ]
  ],
  "./nn.eager.json": [
    "536465",
    [
      81358
    ]
  ],
  "./tr.eager.json": [
    "546323",
    [
      85452
    ]
  ],
  "./hi.eager.json": [
    "947826",
    [
      28803
    ]
  ],
  "./pl.eager.json": [
    "80477",
    [
      39434
    ]
  ],
  "./uk.eager.json": [
    "786385",
    [
      6630
    ]
  ],
  "./fr.eager.json": [
    "90805",
    [
      45746
    ]
  ],
  "./da-x-k12.eager.json": [
    "304420",
    [
      22385
    ]
  ],
  "./en.eager.json": [
    "6166",
    []
  ],
  "./he.eager.json": [
    "649774",
    [
      8431
    ]
  ],
  "./hu.eager.json": [
    "807678",
    [
      64383
    ]
  ],
  "./ja.eager.json": [
    "282280",
    [
      85253
    ]
  ],
  "./ru.eager.json": [
    "78740",
    [
      80049
    ]
  ],
  "./da.eager.json": [
    "24014",
    [
      59647
    ]
  ],
  "./sv-x-k12.eager.json": [
    "537818",
    [
      28611
    ]
  ],
  "./zh-Hans.eager.json": [
    "230178",
    [
      70635
    ]
  ],
  "./sl.eager.json": [
    "703158",
    [
      52407
    ]
  ],
  "./en-GB-x-lbs.eager.json": [
    "854227",
    [
      23236
    ]
  ],
  "./en-GB-x-ukhe.eager.json": [
    "513499",
    [
      89532
    ]
  ],
  "./is.eager.json": [
    "758341",
    [
      72234
    ]
  ],
  "./nl.eager.json": [
    "598471",
    [
      47440
    ]
  ],
  "./en-CA.eager.json": [
    "40177",
    [
      50398
    ]
  ],
  "./nb-x-k12.eager.json": [
    "982271",
    [
      20928
    ]
  ],
  "./el.eager.json": [
    "411852",
    [
      96817
    ]
  ],
  "./it.eager.json": [
    "764840",
    [
      77213
    ]
  ],
  "./fr-CA.eager.json": [
    "543252",
    [
      785
    ]
  ],
  "./ga.eager.json": [
    "827925",
    [
      86418
    ]
  ],
  "./en-AU.eager.json": [
    "339799",
    [
      41896
    ]
  ],
  "./sv.eager.json": [
    "303076",
    [
      6561
    ]
  ],
  "./zh-Hant.eager.json": [
    "325211",
    [
      22639
    ]
  ],
  "./ar.eager.json": [
    "557758",
    [
      24983
    ]
  ],
  "./fi.eager.json": [
    "716676",
    [
      25537
    ]
  ],
  "./cy.eager.json": [
    "398113",
    [
      21582
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 493775;
module.exports = __rspack_async_context;
